import types from './types';

const INITIAL_STATE = {
  isCreatingStatistic: false,
  isFetchingIpa: false,
  isFetchingVendors: false,
  isReporting: false,
  isFetchingContacts: false,
  isFetchingCompanyInfo: false,
  isFetchingForms: false,
  isFetchingResources: false,
  isFetchingFile: false,
  isFetchingLogo: false,
  isFetchingUserAck: false,
  isCreatingUserAck: false,
  isCreatingWebPilotPosing: false,
  isSendingFeedback: false,
  isGettingMeasureReport: false,
  showWebPilotPosting: false,
  isAddingAttestation: false,
  isDownloadingAttestationData: false,
  isGettingAttestationPopupContent: false,
  isCheckingAttestationVisibility: false,
  isFetchingAllAttestationTimestamp: false,
  faxOptOutProviders: [],
  companyNames: [],
  vendorNames: [],
  result: [],
};

const appReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.CREATE_STATISTIC_REQUEST:
      return {
        ...state,
        result: [],
        isCreatingStatistic: true,
      };

    case types.CREATE_STATISTIC_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isCreatingStatistic: false,
      };

    case types.CREATE_STATISTIC_FAILURE:
      return {
        ...state,
        result: [],
        isCreatingStatistic: false,
      };

    case types.GET_IPA_BY_USER_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingIpa: true,
      };

    case types.GET_IPA_BY_USER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingIpa: false,
      };

    case types.GET_IPA_BY_USER_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingIpa: false,
      };

    case types.GET_VENDORS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingVendors: true,
      };

    case types.GET_VENDORS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingVendors: false,
      };

    case types.GET_VENDORS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingVendors: false,
      };

    case types.REPORT_ISSUE_REQUEST:
      return {
        ...state,
        result: [],
        isReporting: true,
      };

    case types.REPORT_ISSUE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isReporting: false,
      };

    case types.REPORT_ISSUE_FAILURE:
      return {
        ...state,
        result: [],
        isReporting: false,
      };

    case types.GET_CONTACTS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingContacts: true,
      };

    case types.GET_CONTACTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingContacts: false,
      };

    case types.GET_CONTACTS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingContacts: false,
      };

    case types.GET_COMPANIES_INFO_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCompanyInfo: true,
      };

    case types.GET_COMPANIES_INFO_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCompanyInfo: false,
      };

    case types.GET_COMPANIES_INFO_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCompanyInfo: false,
      };

    case types.GET_DOWNLOADABLE_FORMS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingForms: true,
      };

    case types.GET_DOWNLOADABLE_FORMS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingForms: false,
      };

    case types.GET_DOWNLOADABLE_FORMS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingForms: false,
      };

    case types.GET_DOWNLOADABLE_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingResources: true,
      };

    case types.GET_DOWNLOADABLE_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingResources: false,
      };

    case types.GET_DOWNLOADABLE_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingResources: false,
      };

    case types.GET_DOWNLOAD_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingFile: true,
      };

    case types.GET_DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingFile: false,
      };

    case types.GET_DOWNLOAD_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingFile: false,
      };

    case types.GET_DOWNLOAD_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingFile: true,
      };

    case types.GET_DOWNLOAD_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingFile: false,
      };

    case types.GET_DOWNLOAD_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingFile: false,
      };

    case types.GET_LOGO_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingLogo: true,
      };

    case types.GET_LOGO_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingLogo: false,
      };

    case types.GET_LOGO_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingLogo: false,
      };

    case types.GET_USER_ACK_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingUserAck: true,
      };

    case types.GET_USER_ACK_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingUserAck: false,
      };

    case types.GET_USER_ACK_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingUserAck: false,
      };

    case types.CREATE_USER_ACK_REQUEST:
      return {
        ...state,
        result: [],
        isCreatingUserAck: true,
      };

    case types.CREATE_USER_ACK_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isCreatingUserAck: false,
      };

    case types.CREATE_USER_ACK_FAILURE:
      return {
        ...state,
        result: [],
        isCreatingUserAck: false,
      };

    case types.CREATE_FAX_OUT_REQUEST:
      return {
        ...state,
        isCreatingWebPilotPosing: true,
      };

    case types.CREATE_FAX_OUT_SUCCESS:
      return {
        ...state,
        isCreatingWebPilotPosing: false,
      };

    case types.CREATE_FAX_OUT_FAILURE:
      return {
        ...state,
        isCreatingWebPilotPosing: false,
      };

    case types.GET_FAX_OUT_REQUEST:
      return {
        ...state,
        isFetchingWebPilotPosing: true,
      };

    case types.GET_FAX_OUT_SUCCESS:
      return {
        ...state,
        isFetchingWebPilotPosing: false,
      };

    case types.GET_FAX_OUT_FAILURE:
      return {
        ...state,
        isFetchingWebPilotPosing: false,
      };

    case types.CREATE_FAX_OUT_REPORT_REQUEST:
      return {
        ...state,
        isFetchingWebPilotPosingReport: true,
      };

    case types.CREATE_FAX_OUT_REPORT_SUCCESS:
      return {
        ...state,
        isFetchingWebPilotPosingReport: false,
      };

    case types.CREATE_FAX_OUT_REPORT_FAILURE:
      return {
        ...state,
        isFetchingWebPilotPosingReport: false,
      };

    case types.SEND_USER_FEEDBACK_REQUEST:
      return {
        ...state,
        result: [],
        isSendingFeedback: true,
      };

    case types.SEND_USER_FEEDBACK_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSendingFeedback: false,
      };

    case types.SEND_USER_FEEDBACK_FAILURE:
      return {
        ...state,
        result: [],
        isSendingFeedback: false,
      };

    case types.GET_MEASURE_REPORT_PRINT_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isGettingMeasureReport: true,
      };

    case types.GET_MEASURE_REPORT_PRINT_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isGettingMeasureReport: false,
      };

    case types.GET_MEASURE_REPORT_PRINT_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isGettingMeasureReport: false,
      };

    case types.UPDATE_SHOW_WEB_PILOT_POSTING:
      return {
        ...state,
        showWebPilotPosting: action.payload,
      };

    case types.UPDATE_FAX_OPT_OUT_PROVIDERS:
      return {
        ...state,
        faxOptOutProviders: action.payload,
      };

    case types.UPDATE_COMPANY_NAMES:
      return {
        ...state,
        companyNames: action.payload,
      };

    case types.UPDATE_VENDOR_NAMES:
      return {
        ...state,
        vendorNames: action.payload,
      };

    case types.GET_ATTESTATION_POPUP_CONTENT_REQUEST:
      return {
        ...state,
        result: [],
        isGettingAttestationPopupContent: true,
      };

    case types.GET_ATTESTATION_POPUP_CONTENT_REQUEST:
      return {
        ...state,
        result: action.payload,
        isGettingAttestationPopupContent: false,
      };

    case types.GET_ATTESTATION_POPUP_CONTENT_REQUEST:
      return {
        ...state,
        result: [],
        isGettingAttestationPopupContent: false,
      };

    case types.CHECK_ATTESTATION_VISIBILITY_REQUEST:
      return {
        ...state,
        result: [],
        isCheckingAttestationVisibility: true,
      };

    case types.CHECK_ATTESTATION_VISIBILITY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isCheckingAttestationVisibility: false,
      };

    case types.CHECK_ATTESTATION_VISIBILITY_FAILURE:
      return {
        ...state,
        result: [],
        isCheckingAttestationVisibility: false,
      };

    case types.ADD_ATTESTATION_REQUEST:
      return {
        ...state,
        result: [],
        isAddingAttestation: true,
      };

    case types.ADD_ATTESTATION_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isAddingAttestation: false,
      };

    case types.ADD_ATTESTATION_FAILURE:
      return {
        ...state,
        result: [],
        isAddingAttestation: false,
      };

    case types.DOWNLOAD_ATTESTATION_REQUEST:
      return {
        ...state,
        result: [],
        isDownloadingAttestationData: true,
      };

    case types.DOWNLOAD_ATTESTATION_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDownloadingAttestationData: false,
      };

    case types.DOWNLOAD_ATTESTATION_FAILURE:
      return {
        ...state,
        result: [],
        isDownloadingAttestationData: false,
      };

    case types.GET_ALL_ATTESTED_TIMESTAMP_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingAllAttestationTimestamp: true,
      };

    case types.GET_ALL_ATTESTED_TIMESTAMP_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingAllAttestationTimestamp: false,
      };

    case types.GET_ALL_ATTESTED_TIMESTAMP_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingAllAttestationTimestamp: false,
      };

    default:
    return state;
  }
};

export default appReducer;
